import React from 'react';

const ForceLogoutModal = ({ isOpen, message, onConfirm }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
            <div className="absolute inset-0 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300"></div>

            <div className="bg-gray-800 border border-gray-700 rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden relative animate-in zoom-in-95 duration-300">
                {/* Top decorative bar */}
                <div className="h-1.5 w-full bg-gradient-to-r from-red-500 to-yellow-500"></div>

                <div className="p-8 text-center">
                    <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6">
                        <i className="ri-error-warning-fill text-3xl text-red-500"></i>
                    </div>

                    <h2 className="text-xl font-bold text-white mb-3">Session Expired</h2>

                    <p className="text-gray-400 mb-8 leading-relaxed">
                        {message || 'You have been logged in on another device. For security reasons, this session has been terminated.'}
                    </p>

                    <button
                        onClick={onConfirm}
                        className="w-full bg-gradient-to-r from-red-500 to-yellow-500 text-white py-3.5 rounded-xl font-bold hover:shadow-lg hover:shadow-red-500/20 active:scale-[0.98] transition-all"
                    >
                        OK, I Understand
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ForceLogoutModal;
